var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconTable = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "M22.5 19.5a2 2 0 0 1-2 2h-17a2 2 0 0 1-2-2v-15a2 2 0 0 1 2-2h17a2 2 0 0 1 2 2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D3F4FF",
  d: "M16.17 17.25h4.335v2.25H16.17zm-6.335 0h4.335v2.25H9.835zm-6.335 0h4.335v2.25H3.5zM16.17 13h4.335v2.25H16.17zm-6.335 0h4.335v2.25H9.835zM3.5 13h4.335v2.25H3.5zm12.67-4.25h4.335V11H16.17zm-6.335 0h4.335V11H9.835zm-6.335 0h4.335V11H3.5zm0-4.25h17v2.25h-17z"
}))));
export default SvgIconTable;